module.exports = {
      id: "spotify-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#spotify",
      toString: function () {
        return this.url;
      }
    }